(function () {
  function initAccessories(root) {
    var scope = root || document;
    scope.querySelectorAll('.filter-btn').forEach(function (btn) {
      if (btn.dataset.bbaccBound === 'true') return;
      btn.dataset.bbaccBound = 'true';
      btn.addEventListener('click', function () {
        scope.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var filter = btn.getAttribute('data-filter');
        scope.querySelectorAll('.prod-card').forEach(function (card) {
          var group = card.closest('.cat-group');
          if (group) group.style.display = '';
          card.style.display = filter === 'all' || card.getAttribute('data-cat') === filter ? '' : 'none';
        });
        if (filter !== 'all') {
          scope.querySelectorAll('.cat-group').forEach(function (group) {
            var visible = group.querySelectorAll('.prod-card[data-cat="' + filter + '"]').length;
            var isBundle = group.id === 'bundle-section';
            group.style.display = visible > 0 || isBundle ? '' : 'none';
          });
        } else {
          scope.querySelectorAll('.cat-group').forEach(function (group) { group.style.display = ''; });
        }
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.06 });
    scope.querySelectorAll('.bbacc-reveal').forEach(function (el) { observer.observe(el); });

    // Swatch selection — updates variant ID and optionally swaps image
    scope.querySelectorAll('[data-swatch]').forEach(function (swatch) {
      if (swatch.dataset.bbaccBound === 'true') return;
      swatch.dataset.bbaccBound = 'true';
      swatch.addEventListener('click', function () {
        var card = swatch.closest('.prod-card');
        if (!card) return;
        card.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');
        var variantId = swatch.dataset.variantId;
        var atcBtn = card.querySelector('[data-acc-add]');
        if (atcBtn && variantId) atcBtn.dataset.variantId = variantId;
        var swatchLabel = card.querySelector('.swatch-label');
        if (swatchLabel && swatch.dataset.color) swatchLabel.textContent = swatch.dataset.color;
        var imageUrl = swatch.dataset.imageUrl;
        if (imageUrl) {
          var img = card.querySelector('.prod-img-photo');
          if (img) img.src = imageUrl;
        }
      });
    });

    scope.querySelectorAll('[data-acc-add]').forEach(function (button) {
      if (button.dataset.bbaccBound === 'true') return;
      button.dataset.bbaccBound = 'true';
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var variantId = Number(button.dataset.variantId);
        if (!variantId) return;
        var originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to add item');
          return response.json();
        }).then(function () {
          button.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
          setTimeout(function () { button.disabled = false; button.textContent = originalText; }, 2000);
        }).catch(function () {
          button.disabled = false;
          button.textContent = originalText;
          window.location.href = '/cart';
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAccessories(document); });
  } else {
    initAccessories(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAccessories(event.target); });
})();
